import Cookies from 'js-cookie';

import { KpnType, AppInfo } from '@/types/common';

const getAppInfo = (): AppInfo => {
    const ua = navigator.userAgent;
    return {
        app: (Cookies.get('kpn') as KpnType) || 'web',
        isAndroid: ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1,
        isRtl: ['ur', 'ar'].some((value) => navigator.language.indexOf(value) === 0),
        isLogin: !!(Cookies.get('token') || (Cookies.get('ud') && Cookies.get('ud') !== '0')),
        bucket: Cookies.get('bucket') || 'mix',
        isInApp: !!Cookies.get('kpn'),
    };
};

export default getAppInfo;
